import type { Config } from "tailwindcss";

export const mountPointId = "tailwind-frame-mount";
export const mountPointSelector = `#${mountPointId}`;

export interface InitialContent {
  bodyEnd?: string;
  bodyStart?: string;
  headEnd?: string;
  headStart?: string;
  tailwindConfig?: Partial<Config>;
}
const defaultHead = `
<style>
  @font-face {
    font-family: InterVariable;
    font-style: normal;
    font-weight: 100 900;
    font-display: swap;
    src: url("https://rsms.me/inter/font-files/InterVariable.woff2?v=4.0") format("woff2");
  }
</style>
`;

const defaultTailwindConfig = {
  theme: {
    fontFamily: {
      sans: ["InterVariable", "ui-sans-serif", "system-ui", "sans-serif"],
    },
  },
};

export const getInitialContent = ({
  headStart = defaultHead,
  headEnd = "",
  bodyStart = "",
  bodyEnd = "",
  tailwindConfig = defaultTailwindConfig,
}: InitialContent) => `
  <!DOCTYPE html>
  <html>
    <head>
      ${headStart}

      <style>
        html, body, ${mountPointSelector} {
          width: 100%;
          height: 100%;
          overflow: hidden;
        }

        body {
          min-height: 0px;
        }

        ${mountPointSelector} .frame-content {
          width: 100%;
          position: relative;
        }

        ${mountPointSelector} .frame-content .wb-h-full {
          height: auto;
        }
      </style>

      <!-- The below script comes from https://unpkg.com/tailwindcss-cdn@3.4.10/tailwindcss-with-all-plugins.js -->
      <script src="${window.TAILWIND_ASSET_PATH || "/assets/tailwindcss-with-all-plugins.js"}"></script>

      <script>
        tailwind.config = ${JSON.stringify(tailwindConfig)};
      </script>

      ${headEnd}
    </head>
    <body>
      ${bodyStart}
      <div id="${mountPointId}"></div>
      ${bodyEnd}
    </body>
  </html>
`;
